import * as react_components from "../reactcomponent.js"
import * as utility from "../services.js"
import * as propertyTypes from "../property_types.js"
import * as datasources from "../common_metadata/datasource.js"
import { ResizeDetector } from "../resize_detector.js"
import React from "react";
interface GaugeProps {
    uid: any;
    values: any;
    queryParameter: any;
    onTextChange(propertyName, value): any;
    context: utility.IContextProps;
    rootPropertyPath: any;
    extendedUid: string;
    metadataSettings: GaugeState;
    settings: any;
}


export class GaugeComponent extends React.Component<GaugeProps, any>{

    constructor(props, context) {
        super(props, context);
        this.state = {};
    }

    handleDataChanged = (allData) => {
        if (this.props.metadataSettings.dataSource) {
            let result = allData[this.props.metadataSettings.dataSource.getDataSourceIdentifier() + this.props.uid];
            if (!result) {
                result = allData[this.props.metadataSettings.dataSource.getDataSourceIdentifier()];
            }

            if (result && result.Data) {
                this.setState({ value: result.Data[0], allRows: result.Data });
            }
        }
    }

    registerComponent = (uid: string, services: string[], datasources: datasources.Datasource[]) => {
        this.props.context.registerComponent(uid, services, this.handleDataChanged, null, datasources);
    }

    UNSAFE_componentWillMount() {
        this.registerComponent(this.props.uid, null, [this.props.metadataSettings.dataSource]);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const oldDataSourceId = !this.props.metadataSettings.dataSource ? null : this.props.metadataSettings.dataSource.getDataSourceIdentifier();

        if (this.props.metadataSettings.dataSource && this.props.metadataSettings.dataSource.getDataSourceIdentifier() != oldDataSourceId) {
            this.registerComponent(nextProps.uid, null, [this.props.metadataSettings.dataSource]);
            this.props.context.loadMissingData(this.props.queryParameter);
        }
    }

    onResize = (w, h) => {
        this.setState({ h: h, w: w });
    }

    componentWillUnmount() {
        this.props.context.unregisterComponent(this.props.uid);
    }

    getMin = () => {
        let min = this.props.metadataSettings.min;
        if (!isNaN(Number(min))) {
            return Number(min);
        }
        else {
            return this.state.value ? this.state.value[this.props.metadataSettings.min] : 0;
        }
    }

    getMax = () => {
        let max = this.props.metadataSettings.max;
        if (!isNaN(Number(max))) {
            return Number(max);
        }
        else {
            return this.state.value ? this.state.value[this.props.metadataSettings.max] : 0;
        }

    }

    render() {
        const value = this.state.value ? this.state.value[this.props.metadataSettings.valueField] : 0;

        return <react_components.ReactColumn width={this.props.metadataSettings.width}>
            <div className="small-box" style={{ backgroundColor: this.props.settings.color }}>
                <ResizeDetector handleWidth handleHeight onResize={this.onResize} />
                <Gauge width={150} height={150} label={this.props.metadataSettings.textField} value={value} min={this.getMin()} max={this.getMax()} />
            </div>
        </react_components.ReactColumn>
    }
};


export class GaugeState extends propertyTypes.BaseComponentProps {
    private textFieldMetadata = new propertyTypes.TranslatableTextProperty("textField", "Text field");
    public textField: string;

    private valueFieldMetadata = new propertyTypes.ColumnProperty("valueField", "Value field", "dataSource");
    public valueField: string;

    private minMetadata = new propertyTypes.ColumnProperty("min", "Min", "dataSource");
    public min: string;

    private maxMetadata = new propertyTypes.ColumnProperty("max", "Max", "dataSource");
    public max: string;

    public dataSource: datasources.Datasource;

    private templateMetadataAll: propertyTypes.BaseProperty[];
    constructor() {
        super();
        const baseMetaData = super.getMetadata();
        this.templateMetadataAll = baseMetaData.concat([this.textFieldMetadata, this.valueFieldMetadata, this.minMetadata, this.maxMetadata, datasources.dataSourceMetadata]);
    };

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.templateMetadataAll;
    }
}

class Gauge extends React.Component<any, any>{
    static defaultProps = {
        label: "",
        min: 0,
        max: 100,
        value: 40,
        width: 400,
        height: 320,
        color: '#fe0400',
        backgroundColor: "#edebeb",
        topLabelStyle: { textAnchor: "middle", fill: "#999999", stroke: "none", fontStyle: "normal", fontVariant: "normal", fontWeight: 'bold', fontStretch: 'normal', lineHeight: 'normal', fillOpacity: 1 },
        valueLabelStyle: { textAnchor: "middle", fill: "#010101", stroke: "none", fontStyle: "normal", fontVariant: "normal", fontWeight: 'bold', fontStretch: 'normal', lineHeight: 'normal', fillOpacity: 1 },
        minMaxLabelStyle: { textAnchor: "middle", fill: "#999999", stroke: "none", fontStyle: "normal", fontVariant: "normal", fontWeight: 'normal', fontStretch: 'normal', fontSize: 14, lineHeight: 'normal', fillOpacity: 1 }
    };

    _getPathValues = (value) => {
        if (value < this.props.min) value = this.props.min;
        if (value > this.props.max) value = this.props.max;

        var dx = 0;
        var dy = 0;
        var gws = 1;

        var alpha = (1 - (value - this.props.min) / (this.props.max - this.props.min)) * Math.PI;
        var Ro = this.props.width / 2 - this.props.width / 10;
        var Ri = Ro - this.props.width / 6.666666666666667;

        var Cx = this.props.width / 2 + dx;
        var Cy = this.props.height / 1.25 + dy;

        var Xo = this.props.width / 2 + dx + Ro * Math.cos(alpha);
        var Yo = this.props.height - (this.props.height - Cy) - Ro * Math.sin(alpha);
        var Xi = this.props.width / 2 + dx + Ri * Math.cos(alpha);
        var Yi = this.props.height - (this.props.height - Cy) - Ri * Math.sin(alpha);

        return { alpha, Ro, Ri, Cx, Cy, Xo, Yo, Xi, Yi };
    };

    _getPath = (value) => {
        var dx = 0;
        var dy = 0;
        var gws = 1;

        var { alpha, Ro, Ri, Cx, Cy, Xo, Yo, Xi, Yi } = this._getPathValues(value);

        var path = "M" + (Cx - Ri) + "," + Cy + " ";
        path += "L" + (Cx - Ro) + "," + Cy + " ";
        path += "A" + Ro + "," + Ro + " 0 0 1 " + Xo + "," + Yo + " ";
        path += "L" + Xi + "," + Yi + " ";
        path += "A" + Ri + "," + Ri + " 0 0 0 " + (Cx - Ri) + "," + Cy + " ";
        path += "Z ";

        return path;
    };

    render() {
        var topLabelStyle = (this.props.topLabelStyle.fontSize
            ? this.props.topLabelStyle
            : { ...this.props.topLabelStyle, fontSize: (this.props.width / 10) });
        var valueLabelStyle = (this.props.valueLabelStyle.fontSize
            ? this.props.valueLabelStyle
            : { ...this.props.valueLabelStyle, fontSize: 18 });
        var { Cx, Ro, Ri, Xo, Cy, Xi } = this._getPathValues(this.props.max);
        return (
            <svg height="100%" version="1.1" width="100%" xmlns="http://www.w3.org/2000/svg" style={{ width: this.props.width, height: this.props.height, overflow: 'hidden', position: 'relative', left: 0, top: 0, display: "block", margin: "auto" }}>
                <defs>
                    <filter id="g3-inner-shadow">
                        <feOffset dx="0" dy="3" />
                        <feGaussianBlur result="offset-blur" stdDeviation="5" />
                        <feComposite operator="out" in="SourceGraphic" in2="offset-blur" result="inverse" />
                        <feFlood floodColor="black" floodOpacity="0.2" result="color" />
                        <feComposite operator="in" in="color" in2="inverse" result="shadow" />
                        <feComposite operator="over" in="shadow" in2="SourceGraphic" />
                    </filter>
                </defs>
                <path fill={this.props.backgroundColor} stroke="none" d={this._getPath(this.props.max)} filter="url(#g3-inner-shadow)" />
                <path fill={this.props.color} stroke="none" d={this._getPath(this.props.value)} filter="url(#g3-inner-shadow)" />
                <text x={this.props.width / 2} y={this.props.height / 8} textAnchor="middle" style={topLabelStyle}>
                    {this.props.label}
                </text>
                <text x={this.props.width / 2} y={this.props.height / 5 * 4} textAnchor="middle" style={valueLabelStyle}>
                    {this.props.value}
                </text>
                <text x={((Cx - Ro) + (Cx - Ri)) / 2} y={Cy + 25} textAnchor="middle" style={this.props.minMaxLabelStyle}>
                    {this.props.min}
                </text>
                <text x={(Xo + Xi) / 2} y={Cy + 25} textAnchor="middle" style={this.props.minMaxLabelStyle}>
                    {this.props.max}
                </text>
            </svg>
        );
    }
}